import { SET_MEMBER_DETAIL } from '../actions';
import { reduxStoreTypes } from '@type/redux-store';

const memberDetail = (state = false, action: reduxStoreTypes.MemberDetailAction) => {
    if (action.type === SET_MEMBER_DETAIL) {
        return action.memberDetail
    }
    return state
}
export default memberDetail